<template>
	<div>
		<el-row style="margin-top: 10px;">
			<el-col class="border" :span="24">
				<div class="d3title" style="padding-bottom: 10px;">门店盈亏
					<el-button class="right" type="primary" size="small" @click="plsc">录入</el-button>
					<input type="file" name="file" style="opacity: 0;position: absolute;display: none;" id="sj"
						@change="xuanzhe($event)" />
					<el-button class="right" type="primary" size="small" @click="exportss">导出</el-button>
				</div>
				<div class='left'>
					<div style="margin-right: 10px;">
						<el-select v-model="storeId" @change="getList()" clearable
							style="width: 150px; margin-right: 30px;" size="small">
							<el-option-group label="营业门店" class="store">
								<el-option v-for="item in storeList" :key="item.id" :label="item.title"
									:value="item.id">
								</el-option>
							</el-option-group>
							<el-option-group label="结业门店">
								<el-option v-for="item in storeEnd" :key="item.id" :label="item.title" :value="item.id">
								</el-option>
							</el-option-group>
						</el-select>
					</div>
					<div style="margin-right: 10px;">
						<el-date-picker @change="getList()" clearable type="monthrange" value-format="yyyy-MM"
							v-model="month" size="small" style="margin-left: 10px;" placeholder="选择月份"></el-date-picker>
					</div>
					<el-button class="right" type="primary" size="small" @click="getList()">筛选</el-button>
					<!-- <el-button class="right" type="primary" size="small" @click="updateWorkerCost">更新人员成本</el-button> -20230826改为导入人员成本而注释 -->
				</div>
				<div id="bar" class='left' style="width: auto;height: 300px"></div>
			</el-col>
		</el-row>
		<div style="margin-top: 20px; width: 100%;display: flex;justify-content: space-around;color:#409eff;font-size:18px;font-weight: 600;"
			v-loading="loading">
			<div>总收入:{{this.allIn.toFixed(2)}} </div>
			<div>总成本:{{this.allCost.toFixed(2)}}  </div>
			<div>人员总成本:{{this.allWorkerCost.toFixed(2)}} </div>
			<div>总盈利:{{this.allProfit.toFixed(2)}} </div>
		</div>
		<div style="margin-top: 10px;" v-loading="loading">
			<el-table :cell-style="{'text-align':'center'}"
				:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable" :data="list"
				tooltip-effect="dark" style="width: 100%">
				<el-table-column label="日期">
					<template slot-scope="scope">
						{{type==1?scope.row.createTime:(month[0]==month[1]?month[0]:month[0]+'-'+month[1])}}
					</template>
				</el-table-column>
				<el-table-column label="门店">
					<template slot-scope="scope">
						{{ scope.row.storeName == null || scope.row.storeId ==46?'小程序' :scope.row.storeName }}
					</template>
				</el-table-column>
				<el-table-column label="收入" prop="payTotalSum" sortable>
					<template slot-scope="scope">
						{{scope.row.payTotalSum}}
					</template>
				</el-table-column>
				<el-table-column label="抖音收入" prop="dy" sortable>
					<template slot-scope="scope">
						{{ scope.row.dy}}
					</template>
				</el-table-column>
				<el-table-column label="租金" prop="zuJin" sortable>
					<template slot-scope="scope">
						<div v-if="scope.row.edits==false">
							{{scope.row.storeName == null || scope.row.storeId ==46?'0':scope.row.zuJin}}
						</div>
						<el-input v-else v-model="scope.row.zuJin" class="w100"></el-input>
					</template>
				</el-table-column>
				<el-table-column label="水电管理费" prop="shuiDianGuanLi" sortable>
					<template slot-scope="scope">
						{{ scope.row.storeName == null || scope.row.storeId ==46?'0':scope.row.shuiDianGuanLi}}
					</template>
				</el-table-column>
				<el-table-column prop="workerCost" sortable label="人员成本">
					<template slot-scope="scope">
						{{ scope.row.storeName == null || scope.row.storeId ==46?'0':scope.row.workerCost}}
					</template>
				</el-table-column>
				<!-- <el-table-column prop="" width="130px" sortable label="考勤扣罚">
					<template slot-scope="scope">
						{{0}}
					</template>
				</el-table-column> -->
				<!-- <el-table-column label="杂费" prop="zaFei" width="130px" sortable>
					<template slot-scope="scope">
						<div v-if="scope.row.edits==false">{{ scope.row.storeName == null || scope.row.storeId ==46?'0':scope.row.zaFei}}</div>
						<el-input v-else v-model="scope.row.zaFei" class="w100"></el-input>
					</template>
				</el-table-column> -->
				<!-- <el-table-column label="社保" prop="sheBao" width="130px" sortable>
					<template slot-scope="scope">
							{{  scope.row.storeName == null || scope.row.storeId ==46?'0':scope.row.sheBao}}
					</template>
				</el-table-column> -->
				<!-- 	<el-table-column label="套餐成本" prop="memberCost" width="130px" sortable>
					<template slot-scope="scope">
						{{ scope.row.memberCost}}
					</template>
				</el-table-column> -->
				<el-table-column prop="yingLi" sortable label="盈利">
					<template slot-scope="scope">
						<span :class="scope.row.yingLi < 0?'red':'0'">
							{{ scope.row.storeName == null || scope.row.storeId ==46?(scope.row.payTotalSum+scope.row.dy-scope.row.memberCost).toFixed(2):scope.row.yingLi.toFixed(2)}}
						</span>
					</template>
				</el-table-column>
				<el-table-column label="编辑">
					<template slot-scope="scope">
						<el-button type="text" v-if="show==false" @click="show=true, getPayTotal(scope.row.storeId) ">查看
						</el-button>
						<div v-else style="display: flex;float: right;">
							<el-button type="text" v-if="scope.row.edits==false" @click="getPayTotals()">返回</el-button>
							<el-button type="text" v-if="scope.row.edits==false" @click="edit(scope.row)">修改</el-button>
							<div v-else style="display: flex;float: right;">
								<el-button type="text" @click="update(scope.row)">保存</el-button>
								<el-button type="text" @click="goback(scope.row)">取消</el-button>
							</div>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
	import {
		url
	} from "../../utils/index.js";
	import echarts from "echarts";
	import {
		formatMoney
	} from "../../utils/index.js"
	export default {
		data() {
			return {
				allIn: 0,
				allCost: 0,
				allWorkerCost: 0,
				allProfit: 0,
				type: 2,
				url: url(),
				show: false,
				list: [],
				month: [],
				storeId: '',
				storeId1: '',
				storeEnd: [],
				storeList: [],
				allStoreList: [],
				storeName: '',
				total: '',
				haircut: '',
				memberTotal: '',
				member: '',
				normal: '',
				quanYi: '',
				first: '',
				sheng: '',
				shu: '',
				shenDu: '',
				edits: false,
				loading: false,
				bar: {
					color: ['#7ba0f3', '#8edbb6'],
					legend: {},
					tooltip: {},
					dataset: {
						source: [
							['updateTime', '销售额', '成本'],
							['2022-06', 43.3, 85.8]
						]
					},
					xAxis: {
						type: 'category'
					},
					yAxis: [{
						type: 'value',
					}],
					series: [
						// { type: 'bar' },
						// { type: 'bar' },
						{
							type: 'bar',
							itemStyle: {
								normal: {
									label: {
										// formatter:"{c}",
										show: true,
										position: "top",
									}
								}
							}
						},
						{
							type: 'bar',
							itemStyle: {
								normal: {
									label: {
										// formatter:"{c}",
										show: true,
										position: "top",
									}
								}
							}
						},
					]
				},
			}
		},
		mounted() {
			var month0;
			if(new Date().getMonth()==0){
				month0 =(new Date().getFullYear()-1)+ '-12'
			}
			else{
				month0 =`${new Date().getFullYear()}-${new Date().getMonth() < 10 ? `0${new Date().getMonth() }` : new Date().getMonth()+1 }`
			}
			this.month = [month0, month0]
			this.getStores()
			this.getList()
		},
		methods: {
			// 文件上传
			plsc: function() {
				var sj = document.querySelector('#sj')
				sj.click()
			},
			xuanzhe: function(val) {
				var sj = document.querySelector('#sj')
				let Formdata = new FormData;
				Formdata.append('file', val.target.files[0])
				let config = {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}
				var that = this
				this.$http.post("joinCost/add", Formdata, config).then(function(
					res) {
					if (res.body.code == 200) {
						this.$message.success("导入成功")
						this.getList()
					} else {
						this.$message.error(res.body.msg)
					}
					var t = setTimeout(function() {
						console.log("刷新页面")
						that.reload()
					}, 4000);
				})
			},
			//导出列表
			exportss() {
				var arr = {}
				if (this.storeId != null && this.storeId != '') {
					arr.storeId = this.storeId
				}
				if (this.month != null) {
					arr.startTime = this.month[0],
						arr.endTime = this.month[1]
				}
				if (this.type == 1) {
					arr.type = 1
					arr.storeId = this.storeId1
				} else {
					arr.type = 2
				}
				window.location.assign(this.url + "joinCost/exportss?startTime=" + arr.startTime +
					"&endTime=" + arr.endTime +
					"&type=" + arr.type +
					"&storeId=" + (arr.storeId ? arr.storeId : '')
				)
			},
			//门店成本列表
			getPayTotals() {
				this.loading = true;
				this.allIn = 0,
				this.allCost = 0,
				this.allWorkerCost = 0,
				this.allProfit = 0,
				this.type = 2
				this.show = false
				let t = setTimeout(() => { //15秒超时
					this.loading = false
					this.$message.error("请求失败")
				}, 15000)
				var a = {};
				if (this.month != null) {
					a.startTime = this.month[0],
					a.endTime = this.month[1]
				}
				if (this.storeId != null && this.storeId != '') {
					a.storeId = this.storeId
				}
				this.$http.get("dOrder/payTotalLists", {
					params: a
				}, {
					emulateJSON: true
				}).then(res => {
					if (res.data.code == 200) {
						this.list = res.body.data;
						var sss = 0;
						this.list.forEach(d => {
							sss = sss + d.memberCost;
							this.$set(d, "edits", false)
							//总收入
							this.allIn += d.payTotalSum + d.dy;
							//总成本
							// if(d.storeName){
							// 	this.allCost += d.zuJin+d.shuiDianGuanLi+d.zaFei+d.memberCost+d.workerCost+d.sheBao;
							// }else{
							// 	this.allCost += d.memberCost;
							// }
							//人员总成本
							if (d.storeName) {
								this.allWorkerCost += d.workerCost;
							} else {
								this.allWorkerCost += 0;
							}
							//总盈利
							if (d.storeName) {
								this.allProfit += d.yingLi;
							} else {
								this.allProfit += d.payTotalSum + d.dy - d.memberCost;
							}
						})
						this.loading = false
						clearTimeout(t)
						console.log("销毁定时器")
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},
			//门店成本详情
			getPayTotal(id) {
				this.storeId1 = id
				this.type = 1;
				var a = {};
				if (this.month != null) {
					a.startTime = this.month[0],
						a.endTime = this.month[1]
				}
				a.storeId = id
				this.$http.get("dOrder/payTotalList", {
					params: a
				}, {
					emulateJSON: true
				}).then(res => {
					if (res.data.code == 200) {
						this.list = res.body.data;
						this.list.forEach(d => {
							this.$set(d, "edits", false)
						})
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},
			//获取柱状图数据
			getOptionsData() {
				this.bar.dataset.source = []
				this.bar.dataset.source[0] = ['updateTime', '销售额', '成本']
				var a = {};
				if (this.month != null) {
					a.startTime = this.month[0],
					a.endTime = this.month[1]
				}
				if (this.storeId != null && this.storeId != '') {
					a.storeId = this.storeId
				}
				this.$http.get("dOrder/optionsData", {
					params: a
				}, {
					emulateJSON: true
				}).then(res => {
					if (res.data.code == 200) {
						const s = res.body.data;
						const i = 1;
						s.forEach(item => {
							this.bar.dataset.source.push([item.updateTime, item.payTotalSum, item.total]);
							this.allCost += item.total
						})
						this.$nextTick(() => {
							this.chart()
						})
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},
			chart() {
				let bar = this.$echarts.init(document.getElementById("bar"))
				bar.setOption(this.bar);
				window.addEventListener("resize", () => {
					bar.resize();
				})
			},
			error() {
				this.$message.error('请选择时间');
			},
		    getList() {
				this.show = false;
				this.getPayTotals();
				this.getOptionsData();
			},
			//获取店铺列表
			getStores() {
				this.$http.get("store/list").then(res => {
					res.body.data.forEach(ele => {
						this.allStoreList.push(ele)
						if (ele.businessType === 1) {
							this.storeEnd.push(ele) //结业门店
						} else {
							this.storeList.push(ele) //营业门店
						}
					})
				})
			},
			//更新人员成本
			updateWorkerCost() {
				this.$http.post("dWorkerCost/updateWorkerCost?time=" + this.month[0]).then(res => {
					if (res.body.code == 200) {
						this.getList()
						this.$message.success("更新成功")
					} else {
						this.$message.error("更新失败")
					}
				})
			},
			edit(i) {
				i.edits = true
			},
			goback(i) {
				i.edits = false
			},
			// 修改租金杂费
			update(i) {
				i.edits = false
				this.show = false
				var a = {}
				if (i.addTime != null && i.addTime != '')
					a.time = i.addTime
				if (i.storeName != null && i.storeName != '')
					a.storeName = i.storeName
				a.zuJin = i.zuJin
				a.zaFei = i.zaFei
				this.$http.post("joinCost/update", JSON.stringify(a)).then(res => {
					if (res.body.code == 200) {
						this.getList()
						this.$message.success("保存成功")
					} else {
						this.$message.error("保存失败")
					}
				})
			},
		}
	}
</script>

<style lang="less" scoped>
	.red {
		color: red;
	}

	.blue {
		width: 6px;
		height: 25px;
		background-color: #00a0e9;
	}

	.right {
		float: right;
		margin-right: 10px;
	}

	.left {
		padding: 10px;
		margin-right: 10px;
		display: flex;
		background-color: #ecebeb;
	}

	.border {
		box-shadow: rgba(13, 13, 13, 0.53) 2px 1px 5px;
		padding: 10px 10px 0px 15px;
	}

	.radius {
		/*border: 2px solid;*/
		border-radius: 8px;
	}

	.d1 {
		color: #ffffff;
		background: linear-gradient(to right, #69a0ff, #3ee2b0);
		font-size: 18px;
		padding: 10px 10px 10px 20px;

		.d1title {
			color: #ffffff;
		}

		.d1content {
			color: #ffffff;
			font-size: 38px;
			font-weight: 800;
			font-family: SourceHanSansCN-Bold;
		}
	}

	.dfont {
		color: #bfbfbf;
		margin-left: 10px;
		margin-top: 5px;
		font-size: 20px;
	}

	.d2 {
		margin-top: 5px;
		line-height: 40px;
		border-bottom: #ecebeb 1px solid;

		.f {
			width: 7px;
			height: 40px;
			background-color: #69a0ff;
		}

		.f01 {
			width: 7px;
			height: 40px;
			background-color: #6fe9c3;
		}

		.f02 {
			width: 7px;
			height: 40px;
			background-color: #7285a5;
		}
	}

	.d3title {
		font-weight: 800;
		font-size: 18px;
	}

	.d4title {
		font-weight: 800;
		font-size: 16px;
		flex: 1;
		background-color: #efefef;
		text-align: center;
	}

	.d4content {
		flex: 1;
		text-align: center;
	}

	.dtitle {
		margin-left: 5px;
		margin-top: 3px;
		line-height: 40px;
		font-size: 22px;
		flex: 10%;
		color: #a7a7a7;
		color: ;
	}

	.dcontent {
		margin-top: 3px;
		line-height: 40px;
		float: right;
		font-size: 24px;
	}
</style>